import {QTh, QIcon, QPopover, QInput} from 'quasar';

const HTh = {
  name: 'HTh',
  extends: QTh,
  render (h) {
    if (!this.props) {
      return h('th', {
        'class': { 'q-table-col-auto-width': this.autoWidth },
        on: { click: () => { console.log(1); } }
      },  [ this.$slots.default ])
    }

    let col
    const
      name = this.$vnode.key,
      child = [ this.$slots.default ]

    if (name) {
      col = this.props.colsMap[name]
      if (!col) { return }
    }
    else {
      col = this.props.col
    }

    /*if ('filter' in col) {
      child['unshift'](
        h(QIcon, {
          props: { name: 'filter_list' },
          staticClass: '',

        }, [
          h(QPopover, {

          }, [
            h(QInput, {
              props: {
                value: ''
              },
              nativeOn: { input: () => { this.props.filterCol('asd') } }
            })
          ])
        ])
      )
    }*/


    if (col.sortable) {
      const action = col.align === 'right'
        ? 'unshift'
        : 'push'

      child['push'](
        h(QIcon, {
          props: { name: this.$q.icon.table.arrowUp },
          staticClass: col.__iconClass,
          class: 'cursor-pointer',
          //nativeOn: { click: () => { this.props.sort(col) } }
        })
      )
    }

    return h('th', {
      'class': [col.__thClass, {
        'q-table-col-auto-width': this.autoWidth,
        'sortable': col.sortable
      }],
      on: { click: () => { col.sortable && this.props.sort(col) } }
    }, child)
  }
};

export default HTh;


// WEBPACK FOOTER //
// ./resources/assets/js/components/HTh/HTh.js